import validator from '@rjsf/validator-ajv8';
import Form from "@rjsf/core";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "./Button";
import { CustomSelectDropdown, PhoneDropdown } from "./CustomSelectDropdown";
import CustomPassword, { ConnectedCustomRePassword } from "./CustomPassword";
import PasswordTips from "./PasswordTips";
import { CustomCheckbox } from "./CustomCheckbox";
import { updateAddressData, validateStepData, scrollToElement } from "../../../utils/functions";
import { CustomInputField } from "./CustomInputField";
import AzureMapsAutocomplete from './AzureMapsAutocomplete';
import { translate } from "../../../../../../../api/utils/i18nHelper";
import { store } from "../../../../../../../config/redux.storage";

export const SignUpForm = (props) => {
  const { activeStep, setActiveStep, form } = props;
  const [isKnownEmail, setIsKnownEmail] = useState(true);
  const currentStep = !!form[activeStep].UISchema ? form[activeStep] : isKnownEmail ? form[activeStep].Schema.properties.knownEmail : form[activeStep].Schema.properties.unknownEmail;
  const myForm = useRef(null);
  const [formData, setFormData] = useState({});
  const [uiSchema, setUiSchema] = useState(currentStep.UISchema);
  const [schema, setSchema] = useState(currentStep.Schema);
  const [validatedData, setValidatedData] = useState({});
  const [isValidating, setIsValidating] = useState(false);
  const { i18n } = store.getState().myPuratos_i18n;

  useEffect(() => {
    setSchema(currentStep.Schema);
    setUiSchema(currentStep.UISchema);
  }, [activeStep, form]);

  const handleClick = () => {
    validateStepData({
      formRef: myForm.current,
      setFormData,
      activeStep,
      setActiveStep,
      form,
      setUiSchema,
      validatedData,
      setValidatedData,
      setIsKnownEmail,
      currentStep,
      setIsValidating
    })
  }

  const handleChildChange = (parentProperties, addressObj) => {
    const objectsProperties = parentProperties.split(',');
    updateAddressData(objectsProperties, addressObj, setFormData, myForm.current.state.formData);
  };

  const clearAddress = (parentProperties) => {
    if (parentProperties) {
      const objectsProperties = parentProperties.split(',');
      updateAddressData(objectsProperties, {}, setFormData, myForm.current.state.formData);
    }
  }

  const CustomForm = (props) => {
    return (
      <Form
        ref={myForm}
        {...props}
        disabled={isValidating}
        fields={props.fields}
      >
        {!!currentStep.PasswordChecklist &&
          <PasswordTips requirements={currentStep.PasswordChecklist}/>}
        <div className={"sign-up__form-buttons"}>
          <Button
            type={"previous"}
            hidden={activeStep === 0}
            disabled={isValidating}
            onClick={() => {
              setActiveStep(activeStep - 1);
              scrollToElement(".steps")
            }}
          >{translate(i18n, 'Previous') || "Previous"}</Button>
          <Button
            type={"next"}
            hidden={activeStep === form.length - 1}
            disabled={isValidating}
            onClick={handleClick}>{translate(i18n, 'Next') || "Next"}</Button>
          <Button
            type={"submit"}
            hidden={activeStep < form.length - 1}
            disabled={isValidating}
            onClick={handleClick}>{translate(i18n, 'Submit') || "Submit"}</Button>
        </div>
      </Form>
    );
  };

  return (
    <>
      <CustomForm
        className={"sign-up__form"}
        schema={schema}
        uiSchema={uiSchema}
        formData={formData}
        validator={validator}
        fields={{
          businessDropdown: CustomSelectDropdown,
          phoneDropdown: PhoneDropdown,
          checkbox: CustomCheckbox,
          password: CustomPassword,
          rePassword: ConnectedCustomRePassword,
          customInput: CustomInputField,
          azureAutocomplete: (props) => <AzureMapsAutocomplete {...props} onChildChange={(parentProperty, addressObj) => handleChildChange(parentProperty, addressObj)} />,
          newAddressBtn: (props) => <Button {...props} type="underline-primary" onClick={() => {
            clearAddress(props.schema?.objToFill)
          }}>{props.schema.title}</Button>
        }}
      /></>
  )
};

SignUpForm.propTypes = {
  activeStep: PropTypes.number.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired
}

